<template>
  <div></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  async created() {
    const data = {
      id: this.getCompanyDetails.id,
      facility_id: this.$route.params.id
    };
    // console.log(data);
    await this.fetchSingleFacility(data);
  },
  computed: {
    ...mapGetters(['getLoggedUser']),
    ...mapGetters('apps', {
      facilityDetails: 'getFacilityDetails',
      companyDetails: 'getCompanyDetails'
    })
  },
  methods: {
    ...mapActions('apps', [
    //   'fetchFacilities',
      'fetchSingleFacility'
    ])
  }
};
</script>

<style>

</style>
